import { useCookies } from '@components/App/Cookies/useCookies'
import { ThemeColors } from '@octopus-do/octopus-storybook'
import {
  CircleCheck as IconCheckCircle,
  Cookie as IconCookie,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const Cookies: React.FC = () => {
  const { hideCookies, hidden, onSetCookie } = useCookies()

  if (hideCookies) {
    return null
  }

  const containerCn = clsJoin(
    css.container,
    hidden && css.hidden,
    ThemeColors.light
  )

  return (
    <div className={containerCn}>
      <div className={css.body}>
        <div className={css.description}>
          <a href="https://octopus.do/sitemap/cookies" className={css.link}>
            We use cookies
          </a>
          <div className={css.icon}>
            <IconCookie />
          </div>
          <span>for better experience.</span>
        </div>
        <button className={css.button} onClick={onSetCookie}>
          <IconCheckCircle />
          <div>I agree</div>
        </button>
      </div>
    </div>
  )
}
